module.exports = __webpack_public_path__ + "static/media/standard.ea85b707.svg";